export const POC_NAME = "pocName";
export const POC_DESIGNATION = "pocDesignation";
export const POC_DEPARTMENT = "pocDepartment";
export const POC_PHONE = "pocPhone";
export const POC_EMAIL = "pocEmail";
export const SCHOOL_ID = "schoolId";

export interface SchoolPoc {
  id?: string;
  pocName: string;
  pocDesignation: string;
  pocDepartment?: string;
  pocPhone: string;
  pocEmail: string;
  schoolId: string;
}
